export default {
  // Primary Theme
  primary: '#1ABC9C', // Emerald
  primaryHover: '#17A589',
  primaryBorderHover: '#148F77',
  primaryClick: '#117A65',
  primaryNew: '#20C997',
  primaryNewHover: '#17B68D',
  primaryNewBorderHover: '#139B75',

  // Accent
  accent: '#A1E5C1', // Light Mint Green
  lighterGreen: '#C9F7DF',
  lightgreen2: '#E1FFF0',

  // Backgrounds
  backgroundLight: '#F5F9F8',
  backgroundCard: '#FFFFFF',
  hoverLight: '#ECFDF5',
  disabled: '#E9ECEF',

  // Text
  textPrimary: '#1A1A1A',
  textSecondary: '#344054',
  textMuted: '#6C757D',
  graytext: '#7C7C84',

  // Border & Divider
  gray: '#D0D5DD',
  grayborder: '#CED4DA',
  whitegray: '#E9ECEF',

  // States
  success: '#30C948',
  warning: '#F8BD26',
  danger: '#D92D20',
  dangerHover: '#C53030',
  redError: '#FF6258',

  // Status Backgrounds
  backgroundStatusPublished: '#E3F8F3',
  backgroundStatusDraft: '#F1F3F4',
  backgroundStatusRevise: '#FFF0F0',
  backgroundStatusApprove: '#D7FFE7',
  backgroundStatusConfirm: '#D9F2FF',

  // Blue for info / tabs
  blue: '#0A6EE1',
  blueHover: '#127EC3',
  blueBorderHover: '#14557B',
  tabBlue: '#14557B',

  // Additional
  ocean: '#146C94',
  oceanDarken: '#0F4C75',

  // Gray tones
  darkGray: '#565353',
  darkGray2: '#4E4E4E',
  darkGray3: '#667085',
  darkGray4: '#4e4e4e',
  darkGray5: '#344054',
  darkGray6: '#D2D2D2',
  darkGray7: '#F9F9F9',
  black: '#000000',
  black2: '#333333',

  // Neutrals
  white: '#FFFFFF',
  graySecondary: '#D0D5DD',
  fullgray: '#888888',

  // Backgrounds / Effects
  wallpaperBlue: '#F0F2F5',
  hoverLightBlue: '#F3FBFD',
  dropdown: '#F3F6F9',

  // ✅ เพิ่มเติมใหม่
  successHover: '#28b03c', // Hover สำหรับปุ่ม success
  successBorder: '#25a035',
  successLight: '#C8FAD0', // สีพื้นหลัง/แถบของสถานะ success อ่อน

  warningLight: '#FFF6DB', // สำหรับพื้นหลัง/บาร์เตือน
  warningBorder: '#F6C344',

  colorWarning: '#F8BD26', // สีหลักของปุ่ม
  warningHover: '#ff922a', // สีเมื่อ hover
  warningBorderHover: '#ff9f43', // สีตอน active

  dangerLight: '#FFE6E6', // สีพื้นหลัง error
  dangerBorder: '#E74C3C',

  info: '#3BAFDA', // สี info เช่น banner, note
  infoHover: '#3498DB',
  infoBackground: '#EAF6FD',

  // 🌸 Purple Theme (ม่วงหรูหรา)
  purple: '#8A2BE2',
  purpleHover: '#9B30FF',
  purpleBorderHover: '#A25CFF',
  purpleLight: '#F5EBFF',

  // 🟦 Indigo / Navy Deep
  indigo: '#5C6AC4',
  indigoHover: '#3F51B5',
  indigoLight: '#E0E7FF',

  // 🌤️ Teal Sky Dreamy
  skyTeal: '#00D2D3',
  skyTealHover: '#00B5B5',
  skyTealLight: '#E0FCFF',

  // ⚪ Neutral Enhancers
  neutralLightest: '#FAFAFA',
  neutralLighter: '#F1F5F9',
  neutralGray: '#CBD5E1',

  // 💎 Glassy / Frosted
  glassWhite10: 'rgba(255, 255, 255, 0.1)',
  glassWhite30: 'rgba(255, 255, 255, 0.3)',
  glassDark10: 'rgba(0, 0, 0, 0.1)',
  glassDark30: 'rgba(0, 0, 0, 0.3)',

  // 🟢 Success Emerald Luxe
  emerald: '#2ECC71',
  emeraldHover: '#27AE60',
  emeraldLight: '#E5F9EF',

  // 🔵 Info Cyan
  cyan: '#00BCD4',
  cyanHover: '#00ACC1',
  cyanLight: '#E0F7FA',

  // 🎨 Overlay & Accent
  blurOverlayLight: 'rgba(255, 255, 255, 0.6)',
  blurOverlayDark: 'rgba(0, 0, 0, 0.5)',

  neutral: '#F4F4F4', // สำหรับ background ทั่วไป (เทาอ่อน)
  neutralDark: '#E0E0E0', // สีเทาใช้ใน border/subtle divider
  lightGray: '#F8F9FA',
  midGray: '#CED4DA',

  inputBorder: '#DADDE1', // ใช้กับ input
  inputFocus: '#20C997', // ขอบตอน focus
  inputPlaceholder: '#A0A0A0',

  overlay: 'rgba(0, 0, 0, 0.3)', // พื้นหลัง overlay modal
  backdrop: 'rgba(255, 255, 255, 0.75)', // โปร่งใสสำหรับ blur

  greenDarken1: '#07A721', // สีเขียวเข้มหลัก

  // Graph / Gradient
  greenGradient: '#20C997',
  greenGradient2: '#009E8E',
  graphGradient: '#A1E5C1',
  graphGradient2: '#47C5B2',
  gradientPrimary: 'linear-gradient(135deg, #20C997 0%, #A1E5C1 100%)',
  gradientDanger: 'linear-gradient(135deg, #D92D20 0%, #FF6258 100%)',
  gradientSuccess: 'linear-gradient(135deg, #30C948 0%, #A1E5C1 100%)',

  // Utility
  transparent: 'transparent',
  current: 'currentColor',
};
